// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { MaterialLevelwiseData } from '../Classes/MaterialLevelwiseData';
import { BusinessTypes } from '../Enums/BusinessTypes';
export class CheckUpdatedMaterialRequest {
  materialLevelwiseData: MaterialLevelwiseData;
  cultureId: number;
  isIgnoreTBLFlag: boolean;
  isFullPartCheck: boolean;
  isStandardLibraryChecked: boolean;
  isLocalLibraryChecked: boolean;
  isePartsChecked: boolean;
  business: BusinessTypes;
}
